module.exports = __webpack_public_path__ + "img/AFRICA_HIGH_GLYCEMIC.f558c686.png";